// 뉴스 페이지 번역
export default {
  list: {
    sectionLabel: 'Stay Updated',
    title: 'Church News',
    description: 'Discover the latest updates, events, and stories from our church community.'
  },
  detail: {
    backToNews: 'Back to News',
    articleNotFound: 'Article not found.',
    shareArticle: 'Share This Article',
    linkCopied: 'Link copied to clipboard!',
    moreArticles: 'More Articles',
    previous: 'Previous',
    next: 'Next'
  }
};
